export default function TextBox({id, disabled, value, label, type, onChangeText, placeholder, onClick, error, className, size}) {

    return (<div className={`${className} flex flex-col`}>
            <label className={`font-dosisbold mb-1 text-${size}`}>{label}</label>
            <textarea  id={id} onClick={onClick} defaultValue={value} disabled={disabled}
                   className={`${disabled && "!bg-gray-100"} resize-none rounded-tl-md rounded-tr-xl rounded-bl-xl rounded-br-3xl w-full focus:ring-0 p-2 text-${size} border ${error ? "border-playmove-red bg-playmove-lightred" : "border-playmove-mediumblue"}`}
                   onChange={onChangeText} type={type} placeholder={placeholder} rows="5"/>
        </div>
    );
}